import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { BsCloudLightningFill } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import CVENG from "../../assets/MauroCristofoli_CV_ENG.pdf";
import CVITA from "../../assets/MauroCristofoli_CV_ITA.pdf";
import { bannerImg } from "../../assets/index";
import { isItalianDevice } from "../../utils/utils";
import { browserName } from "react-device-detect";

const Left = () => {
  const [text] = useTypewriter({
    words: [
      "Frontend Developer",
      "Backend Developer",
      "Full Stack Developer",
      "Software Developer",
    ],
    loop: true,
    typeSpeed: 30,
    deleteSpeed: 20,
    delaySpeed: 2000,
  });

  return (
    <div className="w-full lgl:w-6/12 h-full bg-bodyColor rounded-2xl shadow-testShwdow z-10">
      <div className="w-full h-3/5">
        <img
          className="w-full h-full object-cover rounded-2xl"
          src={bannerImg}
          loading="priority"
          alt="bannerImage"
        />
      </div>
      <div className="w-full h-2/5 flex flex-col justify-between border-t-0 rounded-bl-xl rounded-br-xl">
        <div className="flex flex-col items-center gap-2 py-10">
          <h1 className="text-textColor text-4xl font-semibold">
            Mauro Cristofoli
          </h1>
          <p className="text-base text-designColor tracking-wide">
            {text}
            <Cursor cursorBlinking="false" cursorStyle="|" />
          </p>
          <div className="flex justify-center gap-2 mt-2">
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <a
                href="https://www.linkedin.com/in/mauro-cristofoli-8b52572a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin />
              </a>
            </span>
          </div>
        </div>
        <div className="flex h-14">
          <a
            download={browserName === "Safari"}
            href={isItalianDevice() ? CVITA : CVENG}
            target="_blank"
            className="w-1/2 border-t-[1px] borderRight border-t-zinc-800 text-sm tracking-wide uppercase  gap-2 hover:text-designColor duration-300"
            rel="noreferrer"
          >
            <button className="w-full h-full flex justify-center items-center gap-2">
              {isItalianDevice() ? "Scarica CV" : "Download CV"}
              <BsCloudLightningFill />
            </button>
          </a>
          <a
            href={"mailto:maurocristofolidev@gmail.com"}
            target="_blank"
            className="w-1/2 border-t-[1px] border-t-zinc-800 text-sm tracking-wide uppercase  gap-2 hover:text-designColor duration-300"
            rel="noreferrer"
          >
            <button className="w-full h-full flex justify-center items-center gap-2">
              {isItalianDevice() ? "Contattami" : "Contact me"}
              <FiSend />
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Left;
